function initLPProductShelfNew(id = '') {
  const elemLPProductShelfNew = document.getElementById(id);

  if (elemLPProductShelfNew) {
    new Swiper(elemLPProductShelfNew.querySelector('.swiper'), {
      slidesPerView: 1.5,
      speed: 1000,
      freeMode: true,
      spaceBetween: 16,
      centerInsufficientSlides: true,
      // scrollbar: {
        // el: ".swiper-scrollbar",
        // draggable: true,
        // dragSize: "auto",
      // },
      breakpoints: {
        1440: {
          slidesPerView: 4.3,
          spaceBetween: 32,
          freeMode: false,
          // navigation: {
            // nextEl: '.navigation .swiper-button-next-custom',
            // prevEl: '.navigation .swiper-button-prev-custom',
          // },
        },
        1024: {
          slidesPerView: 3,
          freeMode: false,
        },
        768: {
          slidesPerView: 2.7,
        }
      },
    });
  }
}
